import type { ApiClient } from '@carbonwebmail/api-client'
import type { OrgPlanLimitsDto } from '@carbonwebmail/contracts'
import { useCallback } from 'react'
import { useLoaded } from '../../ui/useLoaded.js'

/**
 * This organisation's allowance, read once.
 *
 * A view model with nothing in it but a read, which is the whole point: there
 * is nothing to change here. A plan is assigned by an operator and the tenant
 * database role cannot write the row, so a screen offering to edit it would be
 * offering something the system refuses.
 */
export function usePlan({ client }: { readonly client: ApiClient }) {
  const load = useCallback(() => client.plan(), [client])
  const { state, reload } = useLoaded<OrgPlanLimitsDto>(
    load,
    'We could not load your plan. Please try again in a moment.',
  )

  return { state, retry: reload }
}
